import { DateStr, PntStationStatusItemDto, formatDate } from '@mi-front/core';
import { Chip, Info, Modal } from '@mi-front/ui';
import { Box } from '@mui/material';
import classNames from 'classnames';
import sortBy from 'lodash/sortBy';
import { Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { SimpleTable } from '../../../../../../components/base/SimpleTable';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';
import { LiveMentionConfidence } from '../../../../components/live-mentions/LiveMentionConfidence';

export function DetailModal({
  item,
  onHide,
  date,
}: {
  date: DateStr;
  item: PntStationStatusItemDto | null;
  onHide: () => void;
}) {
  if (!item) {
    return <Modal show={false} title="" onHide={onHide} />;
  }

  const title = `Status ${item.customId} - ${formatDate(date, 'DD/MM/YY')}`;

  const matchesCount = item.matches.length;
  const scheduledCount = item.schedule.count;

  return (
    <Modal show title={title} onHide={onHide} scrollable size="lg">
      <Grid container sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Info
            title={
              <FormattedMessage
                id="audit.scheduleStatusScreen.detailModal.audio"
                defaultMessage="Archivo"
              />
            }
            data={
              <div>
                <FormattedMessage
                  id="audit.scheduleStatus.detail.customId"
                  defaultMessage="Custom ID"
                />{' '}
                <b>{item.customId}</b>
              </div>
            }
          />
        </Grid>
      </Grid>
      <Grid container sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Info
            title={<FormattedMessage id="common.text.name" defaultMessage="Nombre" />}
            data={item.schedule.name}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Info
            title={
              <FormattedMessage
                id="audit.scheduleStatusScreen.detailModal.status"
                defaultMessage="Status"
              />
            }
            data={() => (
              <SimpleTable
                headers={[
                  {
                    content: (
                      <FormattedMessage
                        id="audit.scheduleStatusScreen.detailModal.schedulesCount"
                        defaultMessage="# schedules"
                      />
                    ),
                    props: { sx: { width: '50%' } },
                  },
                  {
                    content: (
                      <FormattedMessage
                        id="audit.scheduleStatusScreen.detailModal.matchesCount"
                        defaultMessage="# matches"
                      />
                    ),
                    props: { sx: { width: '50%' } },
                  },
                ]}
                rows={[
                  [
                    scheduledCount,
                    {
                      content: (
                        <span
                          className={classNames(matchesCount === 0 && 'text-red font-weight-bold')}
                        >
                          {matchesCount}
                        </span>
                      ),
                    },
                  ],
                ]}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid container sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Info
            title={
              <FormattedMessage
                id="audit.scheduleStatusScreen.detailModal.matches"
                defaultMessage="Matches"
              />
            }
            data={() =>
              !item.matches.length ? (
                <span className="text-muted">
                  <FormattedMessage
                    id="audit.scheduleStatusScreen.detailModal.noMatches"
                    defaultMessage="Sin matches"
                  />
                </span>
              ) : (
                <SimpleTable
                  headers={[
                    {
                      content: (
                        <FormattedMessage
                          id="audit.scheduleStatusScreen.detailModal.matchDatetime"
                          defaultMessage="Fecha y hora emitida"
                        />
                      ),
                      props: { sx: { width: '40%' } },
                    },
                    {
                      content: (
                        <FormattedMessage
                          id="audit.scheduleStatusPntScreen.confidence"
                          defaultMessage="Confianza"
                        />
                      ),
                      props: { align: 'center' },
                    },
                    {
                      content: 'Schedule confirmado',
                      props: { align: 'center' },
                    },
                  ]}
                  rows={sortBy(item.matches, 'datetime').map((match) => [
                    {
                      content: (
                        <Box sx={{ display: 'flex', gap: '0.5rem' }}>
                          <LDate
                            value={match.datetime}
                            day="2-digit"
                            month="2-digit"
                            year="2-digit"
                          />
                          <LTime value={match.datetime} />
                        </Box>
                      ),
                    },
                    {
                      content: <LiveMentionConfidence value={match.confidence} />,
                      props: { align: 'center' },
                    },
                    {
                      content: match.confirmedSchedule ? (
                        <Chip type="primary" size="sm">
                          <div style={{ display: 'flex', gap: '0.5rem' }}>
                            <LTime value={match.confirmedSchedule.datetime} />
                          </div>
                        </Chip>
                      ) : null,
                      props: { align: 'center' },
                    },
                  ])}
                />
              )
            }
          />
        </Grid>
      </Grid>
    </Modal>
  );
}
